import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin":"1rem 0"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"1%"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"74px"} }, null, -1)
const _hoisted_4 = { style: {"flex-basis":"18%"} }
const _hoisted_5 = { style: {"padding-left":"1.22rem"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"flex-basis":"14%"} }
const _hoisted_10 = { style: {"padding-left":".4rem"} }
const _hoisted_11 = { style: {"display":"flex"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"8%","text-align":"center"} }, "-", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"1%"} }, "   ", -1)
const _hoisted_14 = {
  key: 0,
  style: {"flex-basis":"1%"}
}
const _hoisted_15 = {
  key: 1,
  style: {"flex-basis":"8%"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"1%"} }, "   ", -1)
const _hoisted_17 = { style: {"flex-basis":"8%"} }
const _hoisted_18 = {
  key: 1,
  style: {"margin":"1rem 0"}
}
const _hoisted_19 = { style: {"display":"flex","flex-wrap":"nowrap","align-items":"baseline","padding-left":"1.22rem"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"1%"} }, "   ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"74px"} }, "   ", -1)
const _hoisted_22 = {
  key: 2,
  style: {"margin":"1rem 0"}
}
const _hoisted_23 = { style: {"display":"flex","flex-wrap":"nowrap","align-items":"baseline","padding-left":"1.22rem"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"1%"} }, "   ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"74px"} }, "   ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_counterparty_picker_component = _resolveComponent("counterparty-picker-component")!
  const _component_time_only_picker_component = _resolveComponent("time-only-picker-component")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_date_only_picker_component = _resolveComponent("date-only-picker-component")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_order_job_assignees_picker_modal_component = _resolveComponent("order-job-assignees-picker-modal-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.assignees?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignees, (element, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: element.id,
              style: {"display":"flex","flex-wrap":"nowrap","align-items":"baseline","text-align":"left","margin-bottom":"1rem"}
            }, [
              _hoisted_2,
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (!_ctx.isSubcontract && element?.employee)
                    ? (_openBlock(), _createElementBlock("text", _hoisted_6, [
                        _createTextVNode(_toDisplayString(`${element?.employee!.lastname} ${(element?.employee?.firstname ?? '')} ${element?.employee!.lastname ?? ''}`) + " ", 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_text, {
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(element?.employee!.position!.name) + _toDisplayString((element?.employee!.positionGrade?.name ? `, ${element?.employee!.positionGrade?.name}` : '')), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        (!!element?.employee!.fireDate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              (element?.employee!.fireDate)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    size: "small",
                                    type: "warning",
                                    effect: "plain"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Уволен")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isSubcontract)
                    ? (_openBlock(), _createElementBlock("text", _hoisted_8, [
                        _createVNode(_component_counterparty_picker_component, {
                          ref_for: true,
                          ref: "counterpartyPicker",
                          size: "small",
                          "search-placeholder": "Поиск подрядчиков по инициалам, телефону или email",
                          "counterparty-type": _ctx.counterpartyContractorType,
                          "onUpdate:modelValue": [_ctx.onTableSubcontractorChange, ($event: any) => ((element.subcontractor) = $event)],
                          modelValue: element.subcontractor
                        }, null, 8, ["counterparty-type", "onUpdate:modelValue", "modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_time_only_picker_component, {
                      size: "small",
                      modelValue: element.scheduledStartTime,
                      "onUpdate:modelValue": [($event: any) => ((element.scheduledStartTime) = $event), _ctx.onJobAssigneeTimeChanged],
                      style: {"flex-basis":"46%"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _hoisted_12,
                    _createVNode(_component_time_only_picker_component, {
                      size: "small",
                      modelValue: element.scheduledEndTime,
                      "onUpdate:modelValue": [($event: any) => ((element.scheduledEndTime) = $event), _ctx.onJobAssigneeTimeChanged],
                      style: {"flex-basis":"46%"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createVNode(_component_el_link, {
                    size: "small",
                    type: "primary",
                    disabled: !element.scheduledStartTime && !element.scheduledEndTime,
                    underline: false,
                    onClick: (e) => _ctx.onTableAssigneeTimeClearClick(element, e)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" очистить ")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ])
              ]),
              _hoisted_13,
              _createElementVNode("div", null, [
                _createVNode(_component_date_only_picker_component, {
                  size: "small",
                  modelValue: element.scheduledDate,
                  "onUpdate:modelValue": [($event: any) => ((element.scheduledDate) = $event), () => _ctx.onJobAssigneeDateChanged(element)],
                  style: {"min-width":"8rem","width":"9rem"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    disabled: !element.scheduledDate,
                    underline: false,
                    onClick: (e) => _ctx.onTableAssigneeDateClearClick(element, e)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("очистить")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ])
              ]),
              (!_ctx.isSubcontract)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "   "))
                : _createCommentVNode("", true),
              (!_ctx.isSubcontract)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_el_input_number, {
                      modelValue: element.allocationPercent,
                      "onUpdate:modelValue": ($event: any) => ((element.allocationPercent) = $event),
                      size: "small",
                      min: 0,
                      max: 100,
                      onChange: _ctx.emitAssigneesUpdate
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_button, {
                  icon: _ctx.deleteIcon,
                  circle: "",
                  size: "small",
                  onClick: (e) => _ctx.onTableDeleteAssigneeClick(index, e)
                }, null, 8, ["icon", "onClick"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.assignees?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("div", null, [
              _createVNode(_component_el_text, { type: "info" }, {
                default: _withCtx(() => [
                  _createTextVNode("нет исполнителей ☹️")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSubcontract)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _createElementVNode("div", null, [
              _createVNode(_component_el_link, {
                type: "primary",
                size: "small",
                underline: false,
                onClick: _ctx.onTableAddAssigneeClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" добавить исполнителей ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_order_job_assignees_picker_modal_component, {
      ref: "assigneesPickerComponent",
      "default-branch-id": _ctx.branchId,
      onAssigned: _ctx.onEmployeesAssigned
    }, null, 8, ["default-branch-id", "onAssigned"])
  ], 64))
}